import React, { useState } from "react";

import openToast from "../utils/sweetAlert";
import PopupChain from "../components/PopupChain";
import Dropdown from "../components/dropdown/Dropdown";
import DropdownLink from "../components/dropdown/DropdownLink";

import { Link, useNavigate } from "react-router-dom";
import { useHttp } from "../hooks/useHttp";
import { useAuth } from "../providers/auth";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { CButton, CTable, CTableBody, CTableDataCell, CTableHead, CTableHeaderCell, CTableRow } from "@coreui/react";

//Momentjs
import moment from "moment";
import "moment/locale/pt-br";
import LoadingCenter from "../components/LoadingCenter";

const Chains = props => {
  moment.locale();
  const request = useHttp();
  const { user } = useAuth();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [trigger, setTrigger] = useState(false);

  const { data: chains, isLoading } = useQuery(["chains"], () => request({ url: "/chains/list", method: "GET" }));

  const mutationChainsDelete = useMutation(["chains-delete"], (id) => request({ url: `/chains/delete/${id}`, method: "POST", data: {} }), {
    onSuccess: res => {
      if (res.data.error) {
        openToast("error", "Ocorreu um erro", res.data.message);
      }

      if (!res.data.error) {
        openToast("success", "Sucesso", res.data.message);
      }

      queryClient.invalidateQueries(["chains"]);
    }
  });

  const handleDelete = (e, id) => {
    e.preventDefault();
    mutationChainsDelete.mutate(id);
  }

  return (
    <div className="d-flex flex-column">
      <div className="header border-bottom border-top-right-radius-8">
        <span>Grupo de clientes</span>
      </div>

      <div className="dashboard__container-chart">
        <PopupChain admin={user} trigger={trigger} setTrigger={setTrigger} />

        <div className="d-flex flex-row justify-content-between">
          <div></div>

          <CButton type="button" color="primary" className="ml-20 mt-20 mb-10 mr-20" onClick={() => navigate("/chains/new")}>
            Adicionar uma nova chain
          </CButton>
        </div>
        <div className="x-p-20 mb-20">
          {isLoading && <LoadingCenter />}

          {!isLoading && <CTable hover>
            <CTableHead>
              <CTableRow>
                <CTableHeaderCell scope="col">
                  <span className="text-color">Nome</span>
                </CTableHeaderCell>
                <CTableHeaderCell scope="col">
                  <span className="text-color">Data</span>
                </CTableHeaderCell>
                <CTableHeaderCell scope="col" width={44}>
                </CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {(chains?.data && !isLoading) && chains?.data?.map(chain => {
                return (
                  <CTableRow>
                    <CTableDataCell align="middle">
                      <span className="text-color">
                        {chain.name}
                      </span>
                    </CTableDataCell>
                    <CTableDataCell align="middle">
                      <span className="text-color">{moment(chain.createdAt).format("LLL")}</span>
                    </CTableDataCell>
                    <CTableDataCell align="middle" width={44}>
                      <Dropdown bttnSize={34}>
                        <DropdownLink to="/" onClick={e => handleDelete(e, chain.id)}>
                          {mutationChainsDelete.isLoading ? "Excluindo..." : "Deletar"}
                        </DropdownLink>
                        <DropdownLink>
                          <Link to={`/chains/${chain.id}`} style={{ display: "block", color: "var(--text-color)" }}>
                            Editar
                          </Link>
                        </DropdownLink>
                      </Dropdown>
                    </CTableDataCell>
                  </CTableRow>
                );
              })}
            </CTableBody>
          </CTable>}
        </div>
      </div>
    </div >
  );
}

export default Chains;